import { useState } from "react";
import { gql } from "@apollo/client";
import { useLocalSubscription } from "utils/hooks/useLocalSubscription";

const COMMAND_EXECUTION_ERROR = gql`
  subscription commandExecutionError {
    commandExecutionError {
      code
      headers {
        nbbCorrelationId
      }
    }
  }
`;

export const useServerErrorHandling = ({ effect, global }) => {
  const [eventKeys, setEventKeys] = useState([]);

  useLocalSubscription(COMMAND_EXECUTION_ERROR, {
    onSubscriptionData: event => {
      const data = event?.data?.commandExecutionError;
      const message = data?.code;

      if (global) {
        effect({ message });
      } else {
        if (!data?.headers) return;
        const { nbbCorrelationId } = data.headers;
        if (!nbbCorrelationId) return;

        const keys = eventKeys.find(z => z.correlationId === nbbCorrelationId);
        if (keys) {
          const input = { ...keys, message };
          effect(input);
        }
      }
    }
  });

  const storeKey = key => {
    setEventKeys(prev => [...prev, key]);
  };

  return { storeKey };
};
